class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

/* Bendata mobile menu: swipe left to close */
document.addEventListener('DOMContentLoaded', () => {
  const headerDrawer = document.querySelector('header-drawer');
  const drawer = document.querySelector('#menu-drawer');
  const details = document.querySelector('#Details-menu-drawer-container');

  if (!headerDrawer || !drawer || !details) return;

  let startX = 0;
  let startY = 0;
  let startTime = 0;

  drawer.addEventListener('touchstart', (event) => {
    if (!details.hasAttribute('open') || event.touches.length !== 1) return;

    const touch = event.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    startTime = Date.now();
  }, { passive: true });

  drawer.addEventListener('touchend', (event) => {
    if (!details.hasAttribute('open') || event.changedTouches.length !== 1) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - startX;
    const deltaY = touch.clientY - startY;
    const duration = Date.now() - startTime;

    const isLeftSwipe = deltaX <= -55;
    const isMostlyHorizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.25;
    const isQuickEnough = duration <= 800;

    if (isLeftSwipe && isMostlyHorizontal && isQuickEnough) {
      const summary = details.querySelector('summary');
      headerDrawer.closeMenuDrawer(new Event('swipeclose'), summary);
    }
  }, { passive: true });
});
